module.exports = __webpack_public_path__ + "img/rating-capterra.9746c1e7.webp";